import { Box } from '@mui/material';
import { Link } from 'lucide-react';

/** Side of the square, for a row icon that lines up with the tile. */
export const LINK_TILE_PX = 18;

/**
 * A chain on a small bordered square, the mark that leads a registration's
 * row. Teal while its row is selected.
 */
export default function LinkTile({ selected }: { selected?: boolean }) {
    return (
        <Box
            component="span"
            aria-hidden
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: LINK_TILE_PX,
                height: LINK_TILE_PX,
                borderRadius: 1,
                border: '1px solid',
                borderColor: selected ? 'primary.main' : 'divider',
                bgcolor: selected ? 'action.selected' : 'background.paper',
                color: selected ? 'primary.main' : 'text.secondary',
                flexShrink: 0,
                transition: 'all 0.15s ease-in-out',
            }}
        >
            <Link size={10} />
        </Box>
    );
}
